module.exports = __webpack_public_path__ + "img/jamendo.png";